export enum AgentMode {
    Agent = "agent",
    Spec = "spec",
    Ralph = "ralph",
}

export function cycleAgentMode(current: AgentMode, availableModes: AgentMode[]): AgentMode {
    const currentIndex = availableModes.indexOf(current);
    if (currentIndex === -1) {
        return availableModes[0];
    }
    const nextIndex = (currentIndex + 1) % availableModes.length;
    return availableModes[nextIndex];
}

const RALPH_COMMAND_PREFIX = "/ona:ralph";
const SPEC_COMMAND_PREFIX = "/ona:spec";

/**
 * Applies the agent mode prefix to a prompt based on the selected mode.
 */
export function applyAgentModePrefix(prompt: string, agentMode: AgentMode): string {
    if (agentMode === AgentMode.Ralph) {
        return `${RALPH_COMMAND_PREFIX} ${prompt}`;
    }
    if (agentMode === AgentMode.Spec) {
        return `${SPEC_COMMAND_PREFIX} ${prompt}`;
    }
    return prompt;
}

/**
 * Display information for each agent mode.
 */
export const AGENT_MODE_INFO: Record<AgentMode, { label: string; description: string }> = {
    [AgentMode.Agent]: {
        label: "Agent",
        description: "For executing multi-step work.",
    },
    [AgentMode.Spec]: {
        label: "Spec",
        description: "For defining requirements and intent.",
    },
    [AgentMode.Ralph]: {
        label: "Ralph",
        description: "For iterative work with a feedback loop.",
    },
};

/**
 * Returns the display label for an agent mode.
 */
export function getAgentModeLabel(mode: AgentMode): string {
    return AGENT_MODE_INFO[mode]?.label ?? "Agent";
}

/**
 * Returns a brief description for an agent mode.
 */
export function getAgentModeDescription(mode: AgentMode): string {
    return AGENT_MODE_INFO[mode]?.description ?? "";
}
